import React from 'react'

function learning() {
  return (
    <div>learning</div>
  )
}

export default learning